// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__1OI8K","signatureButtonsRight":"ModalSign_signatureButtonsRight__1_xSm"};